import axios from "axios";
const cors = require('cors');






//  export const blcData =   axios.get('http://localhost:1337/blc-home').then(response => {
    
            
          
//         return  [response.data.blcnab, response.data.Blcbody,response.data.blcfooterone];
                
    
    
  
//        });
        
  


export function landingPagaData(){


       return new Promise((resolve,reject)=>{
           
              axios.get('https://blcadmin.brac.net/api/blc-home',cors()).then(response => {
    
            
                     //  console.log(response.data.data.attributes);
                      resolve(response.data.data.attributes);
                             
                 
                 
               
                    });

       })
}


// export function locationPageData() {
    

//        return new Promise((resolve,reject)=>{
   
//            axios.get('http://localhost:1337/blc-location').then(response=>{
   
//            resolve([response.data.locationone]);
//            });
//        });
//    }

//http://34.123.182.161/blc-home
//https://blcadmin.brac.net/blc-home.